module.exports = __webpack_public_path__ + "img/logo_b_l.d1f02e36.png";